import FAQ from '../../components/faq';

const FAQView = () => {
    return <FAQ />;
};

export default FAQView;
